import { $authHost, $host } from "./index";
import jwt_decode from 'jwt-decode'

export const createTag = async (tag) =>{
          // const {data} = await $host.post('api/user/registration', {email, password, role:"ADMIN"})
        const {data} = await $authHost.post('api/tags', tag)
        return data
}

export const fetchTags = async () =>{
    const {data} = await $host.get('api/tags')
    return data
}

export const check = async () =>{
    const {data} = await $authHost.get('api/user/auth')
    localStorage.setItem('token', data.token)
    return jwt_decode(data.token)
}